import { morphSection } from '@theme/section-renderer';

async function submitAtlasListicleBundle(event, bundle) {
  event.preventDefault();

  const variantInput = bundle.querySelector('[data-atlas-bundle-variant]');
  const submit = bundle.querySelector('.atlas-bundles__submit');
  const submitLabel = submit?.querySelector('span');
  const errorMessage = bundle.querySelector('.atlas-bundles__error');
  const variantId = Number(variantInput?.value);
  const originalLabel = submitLabel?.textContent || 'COMPRAR AHORA';

  if (!variantId || !submit) return;

  submit.disabled = true;
  submit.setAttribute('aria-busy', 'true');
  if (submitLabel) submitLabel.textContent = 'AGREGANDO...';
  errorMessage?.classList.add('hidden');

  try {
    const root = window.Shopify?.routes?.root || '/';
    const response = await fetch(root + 'cart/add.js', {
      method: 'POST',
      headers: {
        'Content-Type': 'application/json',
        Accept: 'application/json',
      },
      body: JSON.stringify({
        items: [{ id: variantId, quantity: 1 }],
        sections: 'cart-drawer-section',
        sections_url: window.location.pathname + window.location.search,
      }),
    });
    const result = await response.json();

    if (!response.ok || result.status) {
      throw new Error(result.description || result.message || 'No se pudo agregar al carrito.');
    }

    let drawerSection = result.sections?.['cart-drawer-section'];
    if (!drawerSection) {
      const sectionResponse = await fetch(root + '?section_id=cart-drawer-section');
      if (sectionResponse.ok) drawerSection = await sectionResponse.text();
    }

    if (drawerSection) {
      await morphSection('cart-drawer-section', drawerSection, { mode: 'hydration' });
    }

    await customElements.whenDefined('theme-drawer');
    const drawer = document.querySelector('theme-drawer#cart-drawer');

    if (drawerSection && typeof drawer?.open === 'function') {
      drawer.open();
    } else {
      window.location.href = root + 'cart';
    }
  } catch (error) {
    if (errorMessage) {
      errorMessage.textContent = error instanceof Error ? error.message : 'No se pudo agregar al carrito.';
      errorMessage.classList.remove('hidden');
    }
  } finally {
    submit.disabled = false;
    submit.removeAttribute('aria-busy');
    if (submitLabel) submitLabel.textContent = originalLabel;
  }
}

function initAtlasBundles(bundle) {
  if (!bundle || bundle.dataset.bundlesReady === 'true') return;
  bundle.dataset.bundlesReady = 'true';

  const cards = [...bundle.querySelectorAll('[data-atlas-bundle-option]')];
  const variantInput = bundle.querySelector('[data-atlas-bundle-variant]');
  const price = bundle.querySelector('[data-atlas-bundle-price]');
  const compare = bundle.querySelector('[data-atlas-bundle-compare]');
  const save = bundle.querySelector('[data-atlas-bundle-save]');
  const submit = bundle.querySelector('.atlas-bundles__submit');

  const select = (card) => {
    cards.forEach((item) => {
      const selected = item === card;
      item.classList.toggle('is-selected', selected);
      item.setAttribute('aria-pressed', selected ? 'true' : 'false');
      item.setAttribute('aria-expanded', selected ? 'true' : 'false');
    });

    if (variantInput) variantInput.value = card.dataset.variantId || '';
    if (price) price.textContent = card.dataset.price || '';
    if (compare) compare.textContent = card.dataset.compare || '';
    if (save) save.textContent = `AHORRAS ${card.dataset.save || ''}`;
    if (submit) submit.disabled = !card.dataset.variantId || card.dataset.available !== 'true';
  };

  cards.forEach((card) => card.addEventListener('click', () => select(card)));
  select(cards.find((card) => card.classList.contains('is-selected')) || cards[0]);

  if (bundle.dataset.atlasCartMode === 'listicle') {
    const form = bundle.querySelector('form');
    form?.addEventListener('submit', (event) => submitAtlasListicleBundle(event, bundle));
  }
}

function initAllAtlasBundles(root = document) {
  root.querySelectorAll('[data-atlas-bundles]').forEach(initAtlasBundles);
}

initAllAtlasBundles();
document.addEventListener('shopify:section:load', (event) => initAllAtlasBundles(event.target));
